import { render } from "./PublicationTable.vue?vue&type=template&id=f111b1ac&scoped=true"
import script from "./PublicationTable.vue?vue&type=script&lang=js"
export * from "./PublicationTable.vue?vue&type=script&lang=js"

import "./PublicationTable.vue?vue&type=style&index=0&id=f111b1ac&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f111b1ac"]])

export default __exports__